const isImage = (file: File) => {
	return /^image/.test(file.type);
};

export default isImage;